(() => {
  const tidyFooter = () => {
    const badSocials = [
      'instagram.com/shopify',
      'youtube.com/shopify',
      'tiktok.com/@shopify',
      'twitter.com/shopify',
      'threads.net/@shopify'
    ];
    document.querySelectorAll('footer a[href]').forEach((link) => {
      const href = (link.getAttribute('href') || '').toLowerCase();
      if (badSocials.some((value) => href.includes(value))) {
        const wrapper = link.closest('li') || link.closest('[class*="social"]');
        (wrapper || link).remove();
      }
      const text = (link.textContent || '').trim().toLowerCase();
      if (text.includes('powered by shopify') || text.includes('propulsé par shopify')) {
        const wrapper = link.closest('small') || link.closest('div');
        (wrapper || link).remove();
      }
    });
  };

  const translateStoreLabels = () => {
    if ((document.documentElement.lang || '').split('-')[0] !== 'fr') return;
    const replacements = new Map([
      ['You may also like', 'Vous aimerez aussi'],
      ['You may also like ', 'Vous aimerez aussi'],
      ['View all', 'Voir tout'],
      ['Cart', 'Ton panier']
    ]);
    document.querySelectorAll('h1,h2,h3,h4,a,button').forEach((el) => {
      const value = (el.textContent || '').trim();
      if (replacements.has(value) && el.children.length === 0) {
        el.textContent = replacements.get(value);
      }
    });
  };

  const markVariantSelectors = () => {
    if (!document.querySelector('main[data-template^="product"]')) return;
    document.querySelectorAll('variant-picker, [class*="variant-picker"]').forEach((picker) => {
      picker.classList.add('akuma-variant-picker');
    });
  };

  const addCompatibilityNotice = () => {
    const main = document.querySelector('main[data-template^="product"]');
    if (!main || main.querySelector('.akuma-compatibility-notice')) return;
    if (main.dataset.akumaPhoneCase !== 'true') return;
    const picker = main.querySelector('variant-picker, [class*="variant-picker"]');
    if (!picker || !picker.parentNode) return;

    const notice = document.createElement('div');
    notice.className = 'akuma-compatibility-notice';
    notice.setAttribute('role', 'note');
    const heading = document.createElement('strong');
    heading.textContent = main.dataset.akumaCompatibilityTitle;
    const detail = document.createElement('span');
    detail.textContent = main.dataset.akumaCompatibilityDetail;
    notice.append(heading, detail);
    picker.parentNode.insertBefore(notice, picker);
  };

  const init = () => {
    tidyFooter();
    translateStoreLabels();
    markVariantSelectors();
    addCompatibilityNotice();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

